// TODO (Core): Add unit tests and documentation for these functions
interface PartialWindowSafari {
  pushNotification: {
    permission: string
    requestPermission: (callback: (permission: string) => void) => void
  }
}

declare global {
  interface Window {
    safari: PartialWindowSafari
  }
}

export type NormalizedEnvironment =
  | 'development'
  | 'review'
  | 'staging'
  | 'e2e'
  | 'production'
  | 'test'

export const isBrowser: boolean =
  typeof window !== 'undefined' &&
  typeof document !== 'undefined' &&
  typeof navigator !== 'undefined'

export const isSafari: boolean =
  isBrowser &&
  'safari' in window &&
  typeof window.safari === 'object' &&
  'pushNotification' in window.safari

/**
 * Returns normalized string based on current environment.
 * We have different values across all packages, and this helper normalizes them to NormalizedEnvironment type
 */
export const getNormalizedEnvironment: () => NormalizedEnvironment = () => {
  switch (process.env.NEXT_PUBLIC_ENV) {
    case 'review':
    case 'temporary':
      return 'review'

    case 'staging':
    case 'tst':
      return 'staging'

    case 'production':
    case 'prd':
      return 'production'

    case 'e2e':
      return 'e2e'

    case 'test':
    case 'test_env':
      return 'test'

    default:
      return 'development'
  }
}
